import { Component, input, effect, output, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UnitMix } from '../../models/property';

@Component({ standalone: false,
    selector: 'app-unit-mix-table',
    templateUrl: './unit-mix-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./unit-mix-table.component.scss']
  })
  export class UnitMixTableComponent {

    readonly unitMix = input<UnitMix[]|undefined>(undefined);
    readonly readOnly = input<boolean>(true);
    
    readonly deleteUnitMix = output<UnitMix>();
    readonly editUnitMix = output<UnitMix>();

    public dataSource?: MatTableDataSource<UnitMix>;

    constructor(){
      effect(() => {
        this.processUnitMix();
      });
    }

    get displayedColumns(){
      if(!this.readOnly())
        return ['unitType', 'bedrooms', 'bathroomsFull', 'bathroomsHalf', 'numberOfUnits', 'area', 'avgRent', 'actions'];
      else
        return ['unitType', 'bedrooms', 'bathroomsFull', 'bathroomsHalf', 'numberOfUnits', 'area', 'avgRent'];
    }

    private processUnitMix(){
      this.dataSource=new MatTableDataSource(this.unitMix());
    }

    public onDeleteUnitMix(um:UnitMix){
      this.deleteUnitMix.emit(um);
    }

    public onEditUnitMix(um:UnitMix){
      this.editUnitMix.emit(um);
    }
  }